import { Heading } from "@planningcenter/doxy-web"
import { ChurchCenterCustomFieldApiRecordWithRelationships } from "source/myChurchCenter/Profile/types"

export function Header({
  customField,
}: {
  customField: ChurchCenterCustomFieldApiRecordWithRelationships
}) {
  const fieldName =
    customField.relationships.field_definition.data.attributes.name

  return (
    <div key={customField.id}>
      <Heading level={4} text={fieldName} />
    </div>
  )
}
